// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__-xteL","detailsBorder":"styles_detailsBorder__1R0F1"};